<template>
  <page :title="$tc('manager')">
    <div slot="page-header-right">
      <button class="button is-primary" @click="create">{{$tc('add.manager')}}</button>
    </div>

    <div class="box">
      <b-table
        class="is-middle"
        :data="managers.data"
        :loading="managers.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :total="managers.total"
        :per-page="managers.per_page"
        @page-change="
          (page) => {
            managers.changePage(page);
          }
        "
      >
        <template slot-scope="{ row: manager }">
          <b-table-column :label="$tc('user._name')">
            {{ manager.user.email }}
          </b-table-column>

          <b-table-column :label="$tc('user.role')">
            <span
              class="tag"
              :class="{
                'is-primary': manager.role === 'admin',
                'is-warning': manager.role === 'moderator',
                'is-info': manager.role === 'content',
                'is-secondary': manager.role !== 'admin',
              }"
              >{{ manager.role }}</span
            >
          </b-table-column>

          <b-table-column label="Last Opened At">
            {{ manager.last_opened_at | dateTime }}
          </b-table-column>

          <b-table-column custom-key="actions">
            <div class="is-pulled-right">
              <button class="button mr-2" @click="edit(manager)">
                {{$tc('edit')}}
              </button>

              <button class="button" @click="revoke(manager)">
                {{$tc('revoke')}}
              </button>
            </div>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import EmptyMessage from "@/components/EmptyMessage";
import AddManagerModal from "./AddManagerModal";
import EditManagerModal from "./EditManagerModal";
import moment from 'moment';

export default {
  components: {
    EmptyMessage,
  },

  data() {
    return {
      permissions: new window.RemoteCollection(
        `/admin/api/manager/permissions`
      ),
      managers: new window.PaginatedRemoteCollection("/admin/api/managers")
        .with({ include: ["user", "permissions"] })
        .load(),
    };
  },

  methods: {
    create() {
      this.$buefy.modal.open({
        component: AddManagerModal,
        props: {
          added: () => this.managers.load(),
        },
      });
    },

    edit(manager) {
      this.$buefy.modal.open({
        component: EditManagerModal,
        props: {
          manager,
          updated: () => this.managers.load(),
        },
      });
    },

    revoke(manager) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message: "Revoking manager access.",
        cancelText: "Cancel",
        confirmText: "Revoke",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          new window.Form()
            .delete(`/admin/api/managers/${manager.id}`)
            .then(this.revoked);
        },
      });
    },

    revoked() {
      this.managers.load();
      this.$buefy.toast.open("Manager access revoked");
    },
  },
};
</script>
